import { render, staticRenderFns } from "./categoryForm.vue?vue&type=template&id=2a3363ce&scoped=true&"
import script from "./categoryForm.vue?vue&type=script&lang=js&"
export * from "./categoryForm.vue?vue&type=script&lang=js&"
import style0 from "./categoryForm.vue?vue&type=style&index=0&id=2a3363ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3363ce",
  null
  
)

export default component.exports